/*
 * @Author: 张丛 nhsoft.zhangc
 * @Date: 2024-06-07 16:10:54
 * @LastEditors: 张丛 nhsoft.zhangc
 * @LastEditTime: 2024-06-07 16:12:58
 * @Description: 门店订货控制model
 */

import type {
  IOrderingControlModel,
  IOrderingControlStore,
} from '@monorepo/types/orders/orderingControl/orderingControl.types';
import { tableUpdate } from '@monorepo/utils';

const initState: IOrderingControlStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    offset: 0,
    limit: 50,
  },
};

const OrderingControlStore: IOrderingControlModel = {
  namespace: 'orderingControlStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return { ...state, tableList };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default OrderingControlStore;
